// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.lesson-markdown[data-v-f7c0869e] {\n  background-color: #fff;\n  padding: 20px;\n  overflow-x: hidden;\n  overflow-y: scroll;\n}\n.lesson-markdown[data-v-f7c0869e]::-webkit-scrollbar {\n  display:none;\n}\n", ""]);
// Exports
module.exports = exports;
